import React from 'react';
import { useField, useForm } from 'react-final-form';
import { styled } from '@linaria/react';

import { useOrderStore } from '@blocks/stores/order';

import { Label } from '../../ui';
import { Close } from '../../ui/icon';

const TitleField = styled.div`
  display: flex;
  align-items: flex-start;
`;

const TitleClose = styled.button`
  background-color: transparent;
  border: none;
  border-radius: 50%;
  margin: 0 0 0 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  box-sizing: border-box;

  &:hover {
    cursor: pointer;
    background-color: #f3f7fa;
  }
`;

const TitleContainer = styled.div`
  width: 100%;
  border-width: var(--bb-field-border-width);
  border-style: var(--bb-field-border-style);
  border-radius: var(--bb-field-border-radius);
  background-color: var(--bb-field-background);
  color: var(--bb-field-color);
  border-color: var(--bb-field-border-color);
  padding-top: var(--bb-field-padding-top);
  padding-right: var(--bb-field-padding-right);
  padding-bottom: var(--bb-field-padding-bottom);
  padding-left: var(--bb-field-padding-left);
  font-family: inherit;
  font-size: var(--bb-field-font-size);
  line-height: var(--bb-field-line-height);
  appearance: none;
  outline: none;
  box-sizing: border-box;
  box-shadow: var(--bb-field-box-shadow);
  align-items: center;
`;

const Title = () => {
  const {
    input: { value: title },
  } = useField('title');

  const { setOrderAction } = useOrderStore();

  const { mutators } = useForm();

  const removeTitleOperations = () => {
    mutators.removeTitle();
    setOrderAction({ title: '' });
  };

  return (
    <>
      <Label>Title</Label>
      <TitleField>
        <TitleContainer>{title}</TitleContainer>
        <TitleClose
          onClick={removeTitleOperations}
          type="button"
        >
          <Close />
        </TitleClose>
      </TitleField>
    </>
  );
};

export default Title;
